var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"gameShell"},[_c('Nav'),_c('div',{staticClass:"gameBody",attrs:{"id":"gameBody"}},[_c('router-view')],1),(_vm.$route.name !== 'createGame')?_c('MemberStatus'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }